/**
 * @file: TrialBadge.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { Text, View } from 'react-native';

/**
 * `试用中` right after a menu item the store holds through a trial; the
 * end date stays off the menu. `onDark` sits on the blue drawer and the
 * dark sidebar, `onLight` on a white bar.
 */
export const TrialBadge = memo(
  ({
    trialEndsAt,
    variant = 'onDark',
  }: {
    trialEndsAt: string | null;
    variant?: 'onDark' | 'onLight';
  }) => {
    const { rpx } = useResponsiveContext();
    if (trialEndsAt == null) return null;
    return (
      <View
        style={{
          marginLeft: rpx(8),
          paddingHorizontal: rpx(6),
          paddingVertical: rpx(1),
          borderRadius: rpx(999),
          backgroundColor:
            variant === 'onDark' ? 'rgba(255, 255, 255, 0.22)' : '#eff6ff',
          flexShrink: 1,
        }}
      >
        <Text
          numberOfLines={1}
          style={{
            color: variant === 'onDark' ? '#fff' : '#2563eb',
            fontFamily: FontFamily.NotoSans.Medium,
            fontSize: rpx(10),
          }}
        >
          试用中
        </Text>
      </View>
    );
  },
);
